/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { type ComponentType, useMemo } from 'react';

import Loadable from 'react-loadable';

import { cssMap, jsx } from '@atlaskit/css';

import type { EmojiComponentProps } from './emoji-component';
import { EmojiPlaceholder } from './emoji-placeholder';

export const LazyEmojiComponentLoader: ComponentType<EmojiComponentProps> & Loadable.LoadableComponent = Loadable({
	loader: async () =>
		(await import(/* webpackChunkName: "@atlaskit-internal_EmojiComponent" */ './emoji-component'))
			.EmojiComponent,
	loading: (props: any) => (props.emoji ? <EmojiPlaceholder {...props} /> : null),
});

const styles = cssMap({
	wrapper: {
		display: 'flex',
		justifyContent: 'center',
	},
});

type EmojiRendererProps = {
	emojiId: string | null;
	height?: number;
	width?: number;
};

export const EmojiRenderer = ({ emojiId, height = 40, width = 40 }: EmojiRendererProps): JSX.Element | null => {
	const wrapper = useMemo(
		() => (props: any) => (
			<div css={styles.wrapper} style={{ maxWidth: `${width}px` }} {...props} />
		),
		[width],
	);

	if (!emojiId) {
		return null;
	}

	return (
		<LazyEmojiComponentLoader
			emoji={emojiId}
			height={height}
			wrapper={wrapper}
			renderResourcedEmoji
		/>
	);
};
